import { useEffect, useState } from "react";
import { size } from "../components/devsupport/responsive/breakpoints";

/**
 * A hook that observes the width of the container and sets the data-breakpoint attribute on the container.
 *
 * This is used to apply responsive styles to the container for browsers that don't support container queries.
 */
export function useStitchContainer() {
  const [ro] = useState(
    () =>
      new ResizeObserver((entries) => {
        for (const e of entries) {
          const width = e.contentRect.width;

          let breakpoint: string;
          if (width >= parseInt(size.xxl, 10)) {
            breakpoint = "xxl";
          } else if (width >= parseInt(size.xl, 10)) {
            breakpoint = "xl";
          } else if (width >= parseInt(size.lg, 10)) {
            breakpoint = "lg";
          } else if (width >= parseInt(size.md, 10)) {
            breakpoint = "md";
          } else if (width >= parseInt(size.sm, 10)) {
            breakpoint = "sm";
          } else {
            breakpoint = "xs";
          }
          (e.target as HTMLElement).dataset.breakpoint = breakpoint;
        }
      }),
  );

  useEffect(() => {
    if (CSS.supports("container-type: inline-size")) {
      return function noop() {
        return;
      };
    }

    const element = document.getElementById("stitch-container")!;

    ro.observe(element);

    return function cleanup() {
      ro.unobserve(element);
    };
  }, [ro]);
}
